import { studyActivityBadges, type StudyActivityCounts } from '@flashka/shared/ui';

import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Web builder for the DS-standard card chips (a set's files, then flashcards /
 * quizzes / oral exams / case studies) — pairs the shared `studyActivityBadges` icon set
 * with the localized, pluralized tooltip labels. Loop-safe: call the hook
 * once, use the returned builder per card.
 */
export function useStudyActivityBadgeBuilder() {
  const { t } = useTranslation();
  return useCallback(
    (counts: StudyActivityCounts) =>
      studyActivityBadges(counts, {
        flashcards: t('cardBadges.flashcardsCount', { count: counts.flashcards }),
        quizzes: t('cardBadges.quizzesCount', { count: counts.quizzes }),
        oralExams: t('cardBadges.oralExamsCount', { count: counts.oralExams }),
        caseStudies: t('cardBadges.caseStudiesCount', { count: counts.caseStudies }),
        // Deck tiles only — a set's files chip (see `studyActivityBadges`).
        ...(counts.files === undefined
          ? {}
          : { files: t('cardBadges.filesCount', { count: counts.files }) }),
      }),
    [t],
  );
}
